import app from 'flarum/forum/app';
import PTSitePage from "./components/Pages/PTSitePage";
import PTSiteHRPage from "./components/Pages/PTSiteHRPage";
import PTSiteLevelPage from "./components/Pages/PTSiteLevelPage";
import PTSiteBoxPage from "./components/Pages/PTSiteBoxPage";
import PTSiteCheckPage from "./components/Pages/PTSiteCheckPage";
import PTSiteInfoPage from "./components/Pages/PTSiteInfoPage";
import ConfirmPTSiteListPage from "./components/Pages/ConfirmPTSiteListPage";
import ConfirmPTSiteInfoPage from "./components/Pages/ConfirmPTSiteInfoPage";
import ConfirmPTSiteHRPage from "./components/Pages/ConfirmPTSiteHRPage";
import ConfirmPTSiteCheckPage from "./components/Pages/ConfirmPTSiteCheckPage";
import ConfirmPTSiteBoxPage from "./components/Pages/ConfirmPTSiteBoxPage";
import ConfirmPTSiteLevelPage from "./components/Pages/ConfirmPTSiteLevelPage";
import PTSiteClaimPage from "./components/Pages/PTSiteClaimPage";
import ConfirmPTSiteClaimPage from "./components/Pages/ConfirmPTSiteClaimPage";

app.initializers.add('mattoid-pt-site-information', () => {
  app.routes.ptSiteList = {
    path: '/pt/site/list',
    component: PTSitePage,
  };
  app.routes.ptSiteInfo = {
    path: '/pt/site/info/:siteId/:apiKey',
    component: PTSiteInfoPage,
  };
  app.routes.ptSiteHR = {
    path: '/pt/site/hr/:siteId/:apiKey',
    component: PTSiteHRPage,
  }
  app.routes.ptSiteBox = {
    path: '/pt/site/box/:siteId/:apiKey',
    component: PTSiteBoxPage,
  }
  app.routes.ptSiteLevel = {
    path: '/pt/site/level/:siteId/:apiKey',
    component: PTSiteLevelPage,
  }
  app.routes.ptSiteCheck = {
    path: '/pt/site/check/:siteId/:apiKey',
    component: PTSiteCheckPage,
  }
  app.routes.ptSiteClaim = {
    path: '/pt/site/claim/:siteId/:apiKey',
    component: PTSiteClaimPage,
  }
  app.routes.confirmSiteList = {
    path: '/pt/site/confirm/list',
    component: ConfirmPTSiteListPage,
  }
  app.routes.confirmSiteInfo = {
    path: '/pt/site/info/confirm/:siteId/:confirmId',
    component: ConfirmPTSiteInfoPage,
  }
  app.routes.confirmSiteHR = {
    path: '/pt/site/hr/confirm/:siteId/:confirmId',
    component: ConfirmPTSiteHRPage,
  }
  app.routes.confirmSiteBox = {
    path: '/pt/site/box/confirm/:siteId/:confirmId',
    component: ConfirmPTSiteBoxPage,
  }
  app.routes.confirmSiteCheck = {
    path: '/pt/site/check/confirm/:siteId/:confirmId',
    component: ConfirmPTSiteCheckPage,
  }
  app.routes.confirmSiteLevel = {
    path: '/pt/site/level/confirm/:siteId/:confirmId',
    component: ConfirmPTSiteLevelPage,
  }
  app.routes.confirmSiteClaim = {
    path: '/pt/site/claim/confirm/:siteId/:confirmId',
    component: ConfirmPTSiteClaimPage,
  }
});
